import { useNavigate } from 'react-router-dom';

export const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0f',
      color: '#e2e2f0',
      fontFamily: "'DM Sans', sans-serif",
      padding: '0 1rem',
    }}>
      {/* Header */}
      <div style={{
        maxWidth: 760,
        margin: '0 auto',
        padding: '2rem 0 1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        borderBottom: '1px solid rgba(124,58,237,0.2)',
      }}>
        <button onClick={() => navigate(-1)} style={{
          background: 'rgba(124,58,237,0.15)',
          border: '1px solid rgba(124,58,237,0.3)',
          color: '#a78bfa',
          borderRadius: '8px',
          padding: '0.4rem 0.8rem',
          cursor: 'pointer',
          fontSize: '0.85rem',
        }}>
          ← Volver
        </button>
        <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#7c3aed' }}>TolkX</div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '2rem 0 4rem' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '0.5rem', color: '#fff' }}>
          Política de Privacidad
        </h1>
        <p style={{ color: '#6b6b8a', fontSize: '0.85rem', marginBottom: '2.5rem' }}>
          Última actualización: {new Date().toLocaleDateString('es-DO', { day: '2-digit', month: 'long', year: 'numeric' })}
        </p>

        {[
          {
            title: '1. Información que recopilamos',
            content: `Al registrarte en TolkX recopilamos tu nombre, dirección de correo electrónico y nombre de usuario. Si inicias sesión con Google, también obtenemos tu foto de perfil. Los mensajes, archivos, audios e imágenes que envías se almacenan de forma segura en nuestros servidores de Firebase (Google Cloud).`,
          },
          {
            title: '2. Cómo usamos tu información',
            content: `Usamos tu información exclusivamente para hacer funcionar TolkX: autenticación de sesión, envío de mensajes en tiempo real, notificaciones push, y personalización de tu experiencia (tema, idioma, preferencias). No vendemos ni compartimos tu información con terceros con fines publicitarios.`,
          },
          {
            title: '3. Cookies y almacenamiento local',
            content: `TolkX usa cookies esenciales y localStorage para mantener tu sesión activa, guardar tus preferencias de tema e idioma, y habilitar las notificaciones push (FCM token). Estas cookies son estrictamente necesarias para el funcionamiento de la aplicación y no pueden desactivarse sin afectar su funcionamiento.`,
          },
          {
            title: '4. Firebase y servicios de Google',
            content: `TolkX usa Firebase Authentication, Firestore y Firebase Cloud Messaging de Google. Estos servicios procesan datos según la política de privacidad de Google (https://policies.google.com/privacy). Los datos se almacenan en servidores de Google Cloud con cifrado en tránsito y en reposo.`,
          },
          {
            title: '5. Seguridad',
            content: `Implementamos medidas de seguridad técnicas incluyendo reglas de seguridad de Firestore para garantizar que solo los participantes de un chat puedan acceder a sus mensajes. Las contraseñas nunca se almacenan en texto plano — Firebase Authentication maneja el cifrado de credenciales.`,
          },
          {
            title: '6. Tus derechos',
            content: `Tienes derecho a acceder, corregir o eliminar tu cuenta y datos en cualquier momento. Para eliminar tu cuenta y todos tus datos, contáctanos a través de la app o escríbenos directamente. Procesaremos tu solicitud en un plazo máximo de 30 días.`,
          },
          {
            title: '7. Menores de edad',
            content: `TolkX no está dirigido a menores de 13 años. Si eres menor de 13 años, por favor no uses esta aplicación. Si tomamos conocimiento de que hemos recopilado datos de un menor sin consentimiento parental, eliminaremos esa información de inmediato.`,
          },
          {
            title: '8. Cambios a esta política',
            content: `Podemos actualizar esta política ocasionalmente. Te notificaremos de cambios significativos mediante un aviso en la app o por correo electrónico. El uso continuo de TolkX después de los cambios constituye tu aceptación de la nueva política.`,
          },
          {
            title: '9. Contacto',
            content: `Si tienes preguntas sobre esta política de privacidad, puedes contactarnos en: support@tolkx.app`,
          },
        ].map((section, i) => (
          <div key={i} style={{
            marginBottom: '2rem',
            padding: '1.5rem',
            background: 'rgba(124,58,237,0.06)',
            border: '1px solid rgba(124,58,237,0.15)',
            borderRadius: '12px',
          }}>
            <h2 style={{ fontSize: '1rem', fontWeight: 700, color: '#a78bfa', marginBottom: '0.75rem' }}>
              {section.title}
            </h2>
            <p style={{ fontSize: '0.9rem', lineHeight: 1.7, color: '#c4c4d4', margin: 0 }}>
              {section.content}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};